GP.models.Message = Backbone.Model.extend({
    idAttribute:'msg_id',
    url: function() {
        var to_duid = this.get('to_duid');
        var message = encodeURIComponent(this.get('message'));
        var tag = encodeURIComponent(this.get('tag'));

        var claimable = '';
        if (this.get('claimable')) {
            claimable = '&claimable=1';
        }

        var priority_guarantee = '';
        if (this.get('is_priority_guarantee_reply')) {
            priority_guarantee = '&priority_guarantee_reply=1';
        }
        var mpg_nc = '';
        if (this.get('mpg_nc')) {
            mpg_nc = '&mpg_nc=1';
        }
        var base_url = '/members/msg/add_message/?to_duid='+to_duid;
        return base_url+'&message='+message+'&tag='+tag+claimable+priority_guarantee+mpg_nc;
    }
});
